import { jsx as _jsx } from "react/jsx-runtime";
import classes from './WebChatSurveyEvent.module.scss';
export const ListItem = ({ children }) => (_jsx("div", Object.assign({ role: "listitem", className: classes.content }, { children: children }), void 0));
//# sourceMappingURL=ListItem.js.map